// Global cart utility functions
window.CartUtils = {
  updateCartCount: function() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
          if (cart.item_count === 0) {
            element.classList.add('cart-count-hidden');
          } else {
            element.classList.remove('cart-count-hidden');
          }
        });
        return cart;
      });
  },

  addToCart: function(variantId, quantity = 1) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status && data.status === 422) {
        throw new Error(data.description || 'Could not add item to cart');
      }
      this.updateCartCount();
      return data;
    });
  },

  updateQuantity: function(itemKey, newQuantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: parseInt(newQuantity)
      })
    })
    .then(response => response.json())
    .then(cart => {
      this.updateCartCount();
      return cart;
    });
  }
};